<div class="action-view-page">
    <div class="page-header as-header">
        <h1 class="as-title">{{ title }}</h1>
        @if (display === 'filter') {
            <div class="as-header-functions">
                @if (definition.actionViewId && isSystemView) {
                    <button
                        type="button"
                        class="ace-btn has-icon btn-text icon-dark mb-0"
                        [title]="definition.isFavorite ? 'Remove favorite' : 'Add favorite'"
                        (click)="toggleFavorite(!definition.isFavorite)"
                    >
                        <i
                            class="fa"
                            [class.fa-star]="definition.isFavorite"
                            [class.fa-star-o]="!definition.isFavorite"
                        ></i>
                    </button>
                }
                @if (canRevokeShare) {
                    <button
                        type="button"
                        class="ace-btn has-icon btn-text icon-dark mb-0"
                        title="Stop Sharing"
                        (click)="revokeShare()"
                    >
                        <i class="fa fa-share-alt fa-lg"></i>
                    </button>
                }
                @if (definition.actionViewId) {
                    <button
                        type="button"
                        class="ace-btn has-icon btn-text icon-dark mb-0"
                        title="Reload"
                        (click)="reload()"
                    >
                        <i class="fa fa-refresh fa-lg"></i>
                    </button>
                }
                @if (canSave) {
                    <button
                        type="button"
                        class="ace-btn has-icon btn-text icon-dark mb-0"
                        title="Save"
                        (click)="save()"
                    >
                        <i class="fa fa-save fa-lg"></i>
                    </button>
                }
                <button
                    type="button"
                    class="ace-btn has-icon btn-text icon-dark mb-0"
                    [disabled]="!singleInstanceSelected"
                    [title]="singleInstanceSelected ? 'Save As' : 'Please select a single instance to save'"
                    (click)="saveAs()"
                >
                    <ws-save-as-icon class="ws-stretch"></ws-save-as-icon>
                </button>
            </div>
        }
    </div>

    @if (invalidColumns.length) {
        <div class="alert alert-danger alert-dismissible">
            <button type="button" class="btn-close" aria-label="Close" (click)="dismissInvalidColumns()"></button>
            The following output columns are now invalid; please remove the disputing output columns to proceed.
            <ul>
                @for (column of invalidColumns; track column.colName) {
                    <li>
                        <strong>{{ column.colName }}</strong> because of:
                        @for (offending of column.offendingColumns; track offending) {
                            <span class="badge text-bg-secondary ms-1">{{ offending }}</span>
                        }
                    </li>
                }
            </ul>
        </div>
    }

    @if (loading && !dataLoaded) {
        <div class="text-center p-5"><i class="fa fa-spinner fa-pulse fa-5x"></i></div>
    }

    @if (dataLoaded) {
        @if (display !== 'filter') {
            <p class="lead mb-2">
                <span [innerHTML]="plainEnglish"></span>
                @if (!drilldownMode) {
                    <button type="button" class="btn btn-link btn-sm" (click)="showFilter()">Change</button>
                }
            </p>
        }

        @if (display === 'filter') {
            <p class="lead mb-2"><span [innerHTML]="plainEnglish"></span></p>
            <div class="row">
                <div class="col-lg-3 my-tasks-criteria">
                    <action-view-task-criteria
                        [criteria]="criteria"
                        [taskTypes]="taskTypes"
                        [hasPrivatePermission]="criteriaData?.hasPrivatePermission ?? false"
                        [isTeamMemberAndAssignable]="criteriaData?.isTeamMemberAndAssignable ?? false"
                        [singleInstanceSelected]="singleInstanceSelected"
                        (criteriaChange)="updateCriteria($event)"
                        (taskTypeChange)="taskTypeChanged($event)"
                    />
                </div>
                <div class="col-lg-4 my-tasks-criteria">
                    <action-view-date-criteria
                        [criteria]="criteria"
                        [urgencies]="urgencies"
                        (criteriaChange)="updateCriteria($event)"
                    />
                </div>
                <div class="col-lg-5">
                    <div class="card panel-flat-color secondary-panel date-time-panel">
                        <div class="panel-flat-header mb-0">
                            <div class="header-icon"><i class="fa fa-filter"></i></div>
                            <h3>Filter</h3>
                            <div class="float-end">
                                OR
                                <ws-switch
                                    [(ngModel)]="showOrs"
                                    (selectedOptionChanged)="updateShowOrs($event)"
                                    data-qa="filter-ors-toggle"
                                >
                                </ws-switch>
                            </div>
                        </div>
                        <div class="panel-flat-body action-view-filter-panel">
                            <ws-column-filters
                                [columnFilters]="filterColumns"
                                [showOrs]="showOrs"
                                [hideDelete]="true"
                                (updateColumnFilters)="updateFilterColumns($event)"
                            />
                        </div>
                    </div>
                    <div class="card panel-flat-color secondary-panel date-time-panel">
                        <div class="panel-flat-header mb-0">
                            <div class="header-icon"><i class="fa fa-columns"></i></div>
                            <h3>Output</h3>
                        </div>
                        <div class="panel-flat-body action-view-output-panel">
                            <div class="radio">
                                <label>
                                    <input
                                        type="radio"
                                        name="action-view-output"
                                        value="default"
                                        [checked]="criteria.output === 'default'"
                                        (change)="chooseDefaultOutput()"
                                    />
                                    Default
                                </label>
                            </div>
                            <div class="radio">
                                <label>
                                    <input
                                        type="radio"
                                        name="action-view-output"
                                        value="custom"
                                        [checked]="criteria.output === 'custom'"
                                        (change)="chooseCustomOutput()"
                                    />
                                    Custom
                                    @if (criteria.output === 'custom') {
                                        (<button type="button" class="btn btn-link p-0" (click)="launchCustomOutput()"
                                            >Edit</button
                                        >)
                                    }
                                </label>
                            </div>
                            @if (criteria.output === 'custom' && !criteria.taskTypeID) {
                                <label>
                                    <input
                                        type="checkbox"
                                        [ngModel]="criteria.persistCustomColumns"
                                        (ngModelChange)="updatePersistCustomColumns($event)"
                                    />
                                    Persist on overview drilldown
                                </label>
                            }
                            <action-view-overview-options
                                [criteria]="criteria"
                                [filterColumns]="filterColumns"
                                [loading]="loading"
                                (criteriaChange)="updateCriteria($event)"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-lg-12">
                    <div style="display: flex; justify-content: end; gap: 8px">
                        <button
                            type="button"
                            class="ace-btn btn-primary"
                            [disabled]="criteria.thatAreChoice === completed || loading"
                            (click)="showOverview()"
                        >
                            <i class="fa fa-table"></i> Overview
                        </button>
                        <button
                            type="button"
                            class="ace-btn btn-primary"
                            [disabled]="!filterColumns.length || loading"
                            (click)="showDetailed()"
                        >
                            <i class="fa fa-list-alt"></i> Detailed List
                        </button>
                    </div>
                </div>
            </div>
        }

        @if (display === 'overview') {
            <div class="clearfix"></div>
            @if (loading) {
                <div class="text-center p-4"><i class="fa fa-spinner fa-pulse fa-5x"></i></div>
            } @else {
                <div class="card panel-flat-color primary-panel">
                    <div class="panel-flat-header mb-0">
                        <h3>Overview</h3>
                        <div class="float-end header-button-container">
                            <button
                                type="button"
                                class="ace-btn btn-text has-icon btn-primary"
                                title="Refresh Overview"
                                (click)="showOverview()"
                            >
                                <i class="fa fa-refresh"></i>
                            </button>
                        </div>
                    </div>
                    <div class="panel-flat-body">
                        <action-view-overview
                            [criteria]="criteria"
                            [results]="overviewResults"
                            [isTimedOut]="isOverviewTimedOut"
                            (drilldown)="drilldown($event)"
                        />
                    </div>
                </div>
                <action-view-overview-options
                    [criteria]="criteria"
                    [filterColumns]="filterColumns"
                    [loading]="loading"
                    (criteriaChange)="updateCriteria($event)"
                />
            }
        }

        @if (display === 'detailed') {
            <div class="row no-animate d-flex h-100">
                <div class="col-lg-12">
                    <action-view-detailed
                        [filterToExecute]="drilldownCriteria || criteria"
                        [actionView]="definition"
                        [drilldownFilter]="drilldownCriteria"
                        [drilldownMode]="drilldownMode"
                        [results]="detailedResults"
                        (backToOverview)="backToOverview($event)"
                    />
                </div>
            </div>
        }
    }
</div>
